import { NavLink } from "react-router";
import {
    Sidebar,
    SidebarContent,
    SidebarGroup,
    SidebarGroupContent,
    SidebarGroupLabel,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from "@/components/ui/sidebar";
import React from "react";
import { AccessTag, FeatureFlag } from "@/constants";
import AccessGuard from "@/components/access-guard";
import { useIsPartner } from "@/hooks/useIsPartner";

export const SystemSidebar = ({
    ...props
}: React.ComponentProps<"div"> & {
    side?: "left" | "right";
    variant?: "sidebar" | "floating" | "inset";
    collapsible?: "offcanvas" | "icon" | "none";
}) => {
    const isPartner = useIsPartner();
    return (
        <Sidebar {...props}>
            {props.children}
            <SidebarContent>
                <SidebarGroup>
                    <SidebarGroupLabel>System</SidebarGroupLabel>
                    <SidebarGroupContent>
                        <SidebarMenu>
                            <AccessGuard
                                accessTags={["JETCharge"]}
                                unauthorizedBehaviour={"hide"}
                            >
                                <SidebarMenuItem>
                                    <SidebarMenuButton asChild>
                                        <NavLink
                                            className={"text-default-color"}
                                            to={`/system/central-system`}
                                            end
                                        >
                                            <span>Central system</span>
                                        </NavLink>
                                    </SidebarMenuButton>
                                </SidebarMenuItem>
                            </AccessGuard>
                            <AccessGuard
                                permissions={["webhook_create"]}
                                unauthorizedBehaviour={"hide"}
                            >
                                <SidebarMenuItem>
                                    <SidebarMenuButton asChild>
                                        <NavLink
                                            className={"text-default-color"}
                                            to={`/system/webhooks/webhooks`}
                                            end
                                        >
                                            <span>Webhooks</span>
                                        </NavLink>
                                    </SidebarMenuButton>
                                </SidebarMenuItem>
                            </AccessGuard>
                            <AccessGuard
                                permissions={[
                                    "system_passthrough_manage",
                                    "system_device_provisioning",
                                ]}
                                permissionsSelector="any"
                                unauthorizedBehaviour={"hide"}
                            >
                                <SidebarMenuItem>
                                    <SidebarMenuButton asChild>
                                        <NavLink
                                            className={"text-default-color"}
                                            to={`/system/passthroughs`}
                                            end
                                        >
                                            <span>Passthroughs</span>
                                        </NavLink>
                                    </SidebarMenuButton>
                                </SidebarMenuItem>
                            </AccessGuard>
                            <AccessGuard
                                accessTags={["IlluminateAdmin"]}
                                unauthorizedBehaviour={"hide"}
                            >
                                <SidebarMenuItem>
                                    <SidebarMenuButton asChild>
                                        <NavLink
                                            className={"text-default-color"}
                                            to={`/system/device-schedule-templates`}
                                            end
                                        >
                                            <span>
                                                Device schedule templates
                                            </span>
                                        </NavLink>
                                    </SidebarMenuButton>
                                </SidebarMenuItem>
                            </AccessGuard>
                            <AccessGuard
                                accessTags={[AccessTag.JETCharge]}
                                unauthorizedBehaviour={"hide"}
                            >
                                <SidebarMenuItem>
                                    <SidebarMenuButton asChild>
                                        <NavLink
                                            className={"text-default-color"}
                                            to={`/system/Firmware`}
                                            end
                                        >
                                            <span>Firmware</span>
                                        </NavLink>
                                    </SidebarMenuButton>
                                </SidebarMenuItem>
                            </AccessGuard>
                            <AccessGuard
                                accessTags={[AccessTag.JETCharge]}
                                permissions={["system_device_provisioning"]}
                                featureFlags={[
                                    FeatureFlag.IL_3133_SERVICE_MODEL,
                                ]}
                                overrideAndRestrict={isPartner}
                                unauthorizedBehaviour={"hide"}
                            >
                                <SidebarMenuItem>
                                    <SidebarMenuButton asChild>
                                        <NavLink
                                            className={"text-default-color"}
                                            to={`/system/service-models`}
                                            end
                                        >
                                            <span>Service models</span>
                                        </NavLink>
                                    </SidebarMenuButton>
                                </SidebarMenuItem>
                            </AccessGuard>
                            <AccessGuard
                                permissions={["system_vehicle_model_manage"]}
                                featureFlags={[
                                    FeatureFlag.IL_4063_VEHICLE_MODEL_CATALOG,
                                ]}
                                unauthorizedBehaviour={"hide"}
                            >
                                <SidebarMenuItem>
                                    <SidebarMenuButton asChild>
                                        <NavLink
                                            className={"text-default-color"}
                                            to={`/system/vehicle-model-catalog`}
                                            end
                                        >
                                            <span>Vehicle model catalog</span>
                                        </NavLink>
                                    </SidebarMenuButton>
                                </SidebarMenuItem>
                            </AccessGuard>
                        </SidebarMenu>
                    </SidebarGroupContent>
                </SidebarGroup>
            </SidebarContent>
        </Sidebar>
    );
};
